import React from "react";
import { useParams, Link } from "react-router-dom";
import Footer from "../shared/footer/Footer";
import Blog1 from "./blogs/Blog1";
import Blog2 from "./blogs/Blog2";
import Blog3 from "./blogs/Blog3";
import Blog4 from "./blogs/Blog4";
import Blog5 from "./blogs/Blog5";
import Blog6 from "./blogs/Blog6";
import Blog7 from "./blogs/Blog7";
import Blog8 from "./blogs/Blog8";
import Blog9 from "./blogs/Blog9";

// Simple static blog content map. Add entries here for each blog id.
const BLOGS = {
  "1": {
    title: "Why Hightable is More Than Just a Platform?",
    image: require("../../images/blog1.jpg"),
    content: `<p>Hightable is a meeting place for conversations that matter. We believe curated, meaningful interactions build stronger communities and deeper friendships.</p>
    <p>Here you can create, find, and join tables that match your interests — whether it's a Sunday breakfast or an evening of tarot.</p>`,
  },
  "2": {
    title: "The Cost of Loneliness: Why Connection Matters More Than Ever",
    image: require("../../images/blog2.jpg"),
    content: `<p>Loneliness has a real cost — emotionally and physically. At Hightable we aim to provide low-friction ways to connect and belong.</p>`,
  },
  "3": {
    title: "Conversation Starters: How to Spark Meaningful Connections",
    image: null,
    content: `<p>We all know the awkwardness of small talk—the endless, “Hi, how are you?” loop that never seems to go anywhere. Yet, conversation is the bridge to connection, and connection is at the heart of Hightable.</p>`,
  },
  "4": {
    title: "How to Make Friends in a Busy World",
    image: null,
  content: `<p>
    Why Women Need Their Own Spaces

Women face unique challenges in both professional and personal spaces—bias, societal pressures, and the unspoken expectation to constantly juggle responsibilities. Having a tribe of women who understand, support, and inspire you can make all the difference. It’s not about excluding anyone; it’s about creating an environment where women feel safe to be their authentic selves, share experiences openly, and lift each other up.



Finding Your Tribe

A tribe is more than just a group of friends—it’s a support system. Women thrive in communities where they can exchange ideas, celebrate wins, vent frustrations, and brainstorm solutions without judgment. Hightable makes this easier by connecting women through shared interests, professional goals, hobbies, or life experiences, helping them find people who truly resonate.



The Power of Shared Experiences

Whether it’s navigating career challenges, balancing life and work, or just finding someone to talk to at the end of a long day, shared experiences create bonds. On Hightable, women can join curated spaces where these conversations happen organically. From casual chats to mentorship opportunities, every interaction is designed to foster authentic connection.



How Hightable Supports Women

Safety, inclusivity, and authenticity are our pillars. On Hightable, women can:
	•	Discover like-minded peers and mentors
	•	Share knowledge and experiences in a supportive environment
	•	Build meaningful friendships beyond networking
	•	Celebrate achievements and milestones together

This isn’t just an app—it’s a movement to help women reclaim space, support each other, and grow together.



Why Building Your Tribe Matters

A strong tribe changes everything. Confidence grows, challenges feel less daunting, and life feels richer. Women who have supportive networks report higher resilience, better mental health, and stronger personal and professional growth. Hightable exists to make that possible—because every woman deserves to feel seen, heard, and connected.



The Takeaway

Building your tribe isn’t optional—it’s essential. On Hightable, women have a dedicated space to connect, share, and thrive together. If you’ve been searching for a community where authenticity and support come first, your tribe is waiting. Join, share, and grow—because where women rise together, everything changes.
</p>`,},
  "5": {
    title: "Where Women Rise Together: Build Your Tribe on Hightable",
    image: null,
    content: `<p>
    Why Women Need Their Own Spaces

Women face unique challenges in both professional and personal spaces—bias, societal pressures, and the unspoken expectation to constantly juggle responsibilities. Having a tribe of women who understand, support, and inspire you can make all the difference. It’s not about excluding anyone; it’s about creating an environment where women feel safe to be their authentic selves, share experiences openly, and lift each other up.



Finding Your Tribe

A tribe is more than just a group of friends—it’s a support system. Women thrive in communities where they can exchange ideas, celebrate wins, vent frustrations, and brainstorm solutions without judgment. Hightable makes this easier by connecting women through shared interests, professional goals, hobbies, or life experiences, helping them find people who truly resonate.



The Power of Shared Experiences

Whether it’s navigating career challenges, balancing life and work, or just finding someone to talk to at the end of a long day, shared experiences create bonds. On Hightable, women can join curated spaces where these conversations happen organically. From casual chats to mentorship opportunities, every interaction is designed to foster authentic connection.



How Hightable Supports Women

Safety, inclusivity, and authenticity are our pillars. On Hightable, women can:
	•	Discover like-minded peers and mentors
	•	Share knowledge and experiences in a supportive environment
	•	Build meaningful friendships beyond networking
	•	Celebrate achievements and milestones together

This isn’t just an app—it’s a movement to help women reclaim space, support each other, and grow together.



Why Building Your Tribe Matters

A strong tribe changes everything. Confidence grows, challenges feel less daunting, and life feels richer. Women who have supportive networks report higher resilience, better mental health, and stronger personal and professional growth. Hightable exists to make that possible—because every woman deserves to feel seen, heard, and connected.



The Takeaway

Building your tribe isn’t optional—it’s essential. On Hightable, women have a dedicated space to connect, share, and thrive together. If you’ve been searching for a community where authenticity and support come first, your tribe is waiting. Join, share, and grow—because where women rise together, everything changes.
</p>`,
  },
};

const componentsMap = {
  "1": Blog1,
  "2": Blog2,
  "3": Blog3,
  "4": Blog4,
  "5": Blog5,
  "6": Blog6,
  "7": Blog7,
  "8": Blog8,
  "9": Blog9,
};

const BlogDetail = () => {
  const { id } = useParams();

  // If a dedicated component exists for this id, render it so each page can be edited independently
  const PageComponent = componentsMap[id];
  if (PageComponent) {
    return <PageComponent />;
  }

  // Fallback to the static BLOGS map (useful for quick edits)
  const blog = BLOGS[id] || null;

  if (!blog) {
    return (
      <div className="max-w-4xl mx-auto p-8">
        <h2 className="text-2xl font-semibold">Blog not found</h2>
        <p className="mt-4">We couldn't find the requested blog. <Link to="/blogs" className="text-blue-600">Back to blogs</Link></p>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-4xl mx-auto p-6">
        <Link to="/blogs" className="text-sm text-gray-600">← Back to articles</Link>
        <h1 className="text-4xl font-bold mt-4">{blog.title}</h1>
        {blog.image && (
          <img src={blog.image} alt={blog.title} className="w-full mt-6 rounded-lg object-cover" />
        )}
        <div className="prose max-w-none mt-6" dangerouslySetInnerHTML={{ __html: blog.content }} />
      </div>
      <Footer />
    </div>
  );
};

export default BlogDetail;
